import Link from "next/link";
import React, { useContext, useEffect, useState } from "react";
import styles from "./mobileSliderCard.module.scss";
import { Product } from "../../../../models/home-rows";
import AppContext from "../../../../services/app-context-services";
import { ROUTES } from "../../../../services/router-services";
import { trackEvent } from "../../../../services/ga-services";
import Play from "../../../../../shared-assets/Svg/Play.svg";
import Image from "next/image";

type MobileSliderCard2 = {
  product: Product;
  index: number;
  currentSlide: number;
};


export default function MobileSliderCard({
  product,
  index,
  currentSlide
}: MobileSliderCard2) {
  
  const { setShowLoginPopup , isIntlUser } = useContext(AppContext);

  const [url, setUrl] = useState("");

  useEffect(() => {
    if (!product?.id || isIntlUser) return;

    setUrl(ROUTES.product(product));
  }, [product?.product_type, product?.id, product?.name_english]);

  const checkUserStatus = e => {
    trackEvent("Home Item", product?.name, product?.id.toString() ?? "");
    if (isIntlUser) {
      e.preventDefault();
      e.stopPropagation();
      setShowLoginPopup(true);
    }
  };

  return (
    <>
      {isIntlUser ? (
        <div onClick={checkUserStatus}>
          <div className={styles.card}>
            {product?.avatar?.xhdpi && (
              <Image
                // src={product?.feature_avatar?.xhdpi}
                src={product?.avatar?.xxhdpi}
                height={740}
                width={512}
              />
            )}
            <div className={styles.title}>
              <span>{product?.name}</span>
            </div>
          </div>
        </div>
      ) : (
        <Link href={url} prefetch={false} key={product?.id}>
          <a
            className={`${styles.posterWrapper} ${
              index === currentSlide ? styles.slideShow : styles.slideHide
            }  `}
          >
            <img src={product?.avatar?.xhdpi} alt="slider " />
            <div className={styles.info}>
              <div className={styles.title}>{product?.name}</div>
              <button className={styles.button}>
                <div className={styles.iconButton}>
                  <Play />
                </div>
                تماشا
              </button>
            </div>
          </a>
        </Link>
      )}
    </>
  );
}
